import type { AuthStorage } from './auth-storage.interface'
import type { AuthResponse } from './auth.interface'

export class AuthService {
  #authStorageRepository: AuthStorage

  static #AuthService: AuthService

  static getInstance(authStorageRepository: AuthStorage) {
    if (!AuthService.#AuthService) {
      AuthService.#AuthService = new AuthService(authStorageRepository)
    }
    return AuthService.#AuthService
  }

  constructor(authStorageRepository: AuthStorage) {
    this.#authStorageRepository = authStorageRepository
  }

  save(data: AuthResponse) {
    this.#authStorageRepository.saveToken(data)
  }
}
